import {AxiosResponse} from "axios";
import v2 from "../v2";

export async function fetchPassDispatchOrder(region:string,limit:number,skip:number,startDate?:string,endDate?:string):Promise<AxiosResponse<any>>{
    return await v2({
        url:`/operation/dispatchWorkOrder`,
        params:{
            query:{
                region,
                createdAt:{
                    $gte:startDate,
                    $lt:endDate
                },
                state: 1,//审核通过
            },
            limit,
            sort: { _id: 1 },
            skip,
        }
    })
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/operation/dispatchWorkOrder.ts